import classNames from 'clsx'

import useContentBlock from './useContentBlock'
import styles from './ContentBlock.module.scss'
import {
  type ContentSize,
  type ContentBlock as ContentBlockType,
  ContentSizeEnum,
} from '../../../shared/types'
import { parentMeta } from './type'
import Slideshow from './Slideshow/Slideshow'
import { renderContent } from './renderContent'
import { CopyContainerProps } from '../../common/copy/CopyContainer/CopyContainer'

interface ContentBlockProps {
  parentMeta?: parentMeta
  filePath?: string
  contentBlock?: ContentBlockType
  className?: string
  copyContainerStyles?: CopyContainerProps
}

const ContentBlock = (props: ContentBlockProps) => {
  const { parentMeta, contentBlock, className, filePath, copyContainerStyles } =
    props

  const {} = useContentBlock({ contentBlock, filePath })

  return (
    <div
      className={classNames(
        styles.contentBlockRoot,
        className,
        contentBlock?.size === ContentSizeEnum.Small ? styles.small : ''
      )}
    >
      {/* iterate over all content items, and render respective Content Types, or display as slideshow*/}
      {contentBlock?.slideshow ? (
        <Slideshow
          contentBlock={contentBlock}
          filePath={filePath}
          parentMeta={parentMeta}
          autoplayDelay={contentBlock?.autoplayDelay || 3000}
        />
      ) : (
        contentBlock?.content.map((content, index) =>
          renderContent({
            content,
            filePath,
            parentMeta,
            index,
            size: contentBlock?.size,
            copyContainerStyles,
          })
        )
      )}
    </div>
  )
}

export default ContentBlock
